import confetti from "canvas-confetti";

/**
 * Mem-branded confetti configuration
 * Colors chosen to match Mem's design system
 */
const MEM_CONFETTI_COLORS = [
  "#6792FF", // Blueprint 300
  "#E6EDFF", // Blueprint 100
  "#FF361A", // Editor 400
  "#FF8170", // Editor 200
  "#E4D6B9", // Latte 300
  "#F9F1E2", // Latte 0
];

/**
 * Triggers a celebration confetti effect
 * Designed for the Getting Started guide completion
 * @param element - Optional HTML element to use as the origin point for confetti
 */
export function triggerCelebrationConfetti(element?: HTMLElement): void {
  const count = 200;

  // Calculate origin position from element if provided
  let origin: { x: number; y: number } = { x: 0.5, y: 0.7 };

  if (element) {
    const rect = element.getBoundingClientRect();
    // Calculate center of the element relative to viewport
    origin = {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight,
    };
  }

  const defaults = {
    origin,
    colors: MEM_CONFETTI_COLORS,
  };

  function fire(particleRatio: number, opts: confetti.Options): void {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  // Fire multiple bursts for a more dramatic effect
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}

/**
 * Triggers a simple confetti burst
 * Can be used for other celebrations throughout the app
 */
export function triggerSimpleConfetti(): void {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: MEM_CONFETTI_COLORS,
  });
}
